// Given a snippet of newline separated groups, find the line numbers where the groups
// start and end. For example, with a snippet like:
//
//  import Customerio from 'customerio'
//
//  let cio = new Customerio();
//  cio.set('apikey', 'siteid');
//
//  cio.sendMessage();
//
// ... there are three groups: [0, 1], [2,3], and [5,6]
export function findGroupsInSnippet(content: string) {
  // We want to keep the newlines in the split array to be able to compare
  // later, so we use lookahead regex instead of a string.
  let lines = content.split(/(?=\n)/).map((line) => line.replace(/^ +| +$/gm, ''));

  let groups: [number, number][] = [];
  let current = 0;

  lines.forEach((line, i) => {
    // If the previous line was also a newline, skip this one.
    if (line === '\n' && lines[i - 1] === '\n') {
      current = i + 1;
      return;
    }

    if (line === '\n') {
      groups.push([current, i]);
      current = i + 1;
    }
  });

  if (current !== lines.length) {
    groups.push([current, lines.length]);
  }

  return groups;
}
